import { useState, useEffect } from 'react';
import { Group, Paper, Stack, Text } from '@mantine/core';
import { useNavigate } from 'react-router';
import { useDealReportRepository } from '../../rpc';
import logger from '@ayocore/platform/common/helpers/logger';
import { buildDealsListUrl } from './buildDealsListUrl';

const fmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 });

const glassStyle = {
  background: 'rgba(255, 255, 255, 0.28)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: 'none',
} as const;

interface DealStatItem {
  id: number;
  name: string;
  color: string;
  total: number;
}

/**
 * Блок сделок текущего пользователя по статусам.
 */
export function UserDealsWelcomeBlock() {
  const navigate = useNavigate();
  const dealReportRepository = useDealReportRepository();
  const [dealStats, setDealStats] = useState<DealStatItem[]>([]);

  useEffect(() => {
    dealReportRepository
      .getWelcomeDealStats()
      .then(data => setDealStats(data as DealStatItem[]))
      .catch(err => logger.error('Failed to load deal stats:', err));
  }, []);

  if (dealStats.length === 0) return null;

  return (
    <Paper p='md' radius='lg' style={glassStyle}>
      <Stack gap='sm'>
        <Text size='xs' fw={500}>
          Твои сделки
        </Text>
        <Group gap='xl' wrap='nowrap'>
          {dealStats.map(item => (
            <Stack
              key={item.name}
              gap={0}
              onClick={() => navigate(buildDealsListUrl({ statusId: item.id, mine: true }))}
              style={{
                flex: 1,
                minWidth: 0,
                backgroundColor: '#ffffff5e',
                padding: '6px 8px',
                borderRadius: 8,
                cursor: 'pointer',
              }}
            >
              <Text size='xs' c='dimmed'>
                {item.name}
              </Text>
              <Text size='sm' fw={600}>
                {fmt.format(item.total)} ₽
              </Text>
            </Stack>
          ))}
        </Group>
      </Stack>
    </Paper>
  );
}
